"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  DEFAULT_FLOOR_SIZE: () => DEFAULT_FLOOR_SIZE,
  Editor: () => Editor,
  EditorContent: () => EditorContent,
  MAP_THEME: () => MAP_THEME,
  MIN_ELEMENT_SIZE: () => MIN_ELEMENT_SIZE
});
module.exports = __toCommonJS(src_exports);

// src/editor.tsx
var import_react8 = require("react");
var import_react_konva8 = require("react-konva");
var import_styled_components2 = __toESM(require("styled-components"));
var import_date_fns = require("date-fns");

// src/components/editor/Image.tsx
var import_react = require("react");
var import_use_image = __toESM(require("use-image"));
var import_react_konva = require("react-konva");

// src/constants.ts
var MIN_ELEMENT_SIZE = 10;
var DEFAULT_FLOOR_SIZE = { width: 700, height: 600 };
var MAP_THEME = {
  cornerRadius: 2,
  fontFamily: "Figtree, sans-serif",
  fontSize: 9,
  fontStyle: "500"
};

// src/components/editor/theme.ts
var getStrokeStyle = (theme = {}, isSelected = false) => {
  const stroke = isSelected && theme.selectionColor || theme.stroke;
  return { ...stroke && { stroke, strokeWidth: 1 } };
};
var getBoxStyle = (theme = {}, isSelected = false) => ({
  ...getStrokeStyle(theme, isSelected),
  ...theme.cornerRadius !== void 0 && { cornerRadius: theme.cornerRadius }
});
var getRingStyle = ({ selectionRingColor } = {}) => ({
  ...selectionRingColor && {
    stroke: selectionRingColor,
    strokeWidth: 4,
    fillAfterStrokeEnabled: true
  }
});
var getTextStyle = ({
  textColor,
  fontSize,
  fontFamily,
  fontStyle
} = {}) => ({
  ...textColor && { fill: textColor },
  ...fontSize !== void 0 && { fontSize },
  ...fontFamily && { fontFamily },
  ...fontStyle && { fontStyle }
});
var keepAnchorInside = (transformer, position) => {
  if ((transformer == null ? void 0 : transformer.getActiveAnchor()) !== "bottom-right" || transformer.rotation()) {
    return position;
  }
  const stage = transformer.getStage();
  return {
    x: Math.max(
      transformer.x() + MIN_ELEMENT_SIZE,
      Math.min(position.x, stage.width())
    ),
    y: Math.max(
      transformer.y() + MIN_ELEMENT_SIZE,
      Math.min(position.y, stage.height())
    )
  };
};
var getTransformerProps = (theme = {}, {
  resize = false,
  rotate = true,
  keepRatio = false
} = {}, transformerRef) => {
  var _a;
  return {
    rotateEnabled: rotate,
    rotationSnaps: [0, 90, 180, 270],
    resizeEnabled: resize,
    enabledAnchors: resize ? ["bottom-right"] : [],
    keepRatio,
    centeredScaling: !resize,
    ignoreStroke: resize,
    anchorDragBoundFunc: (_, position) => keepAnchorInside(transformerRef == null ? void 0 : transformerRef.current, position),
    boundBoxFunc: (oldBox, newBox) => resize && (newBox.width < MIN_ELEMENT_SIZE || newBox.height < MIN_ELEMENT_SIZE) ? oldBox : newBox,
    ...theme.selectionColor && {
      padding: 1,
      borderStroke: (_a = theme.selectionRingColor) != null ? _a : theme.selectionColor,
      borderStrokeWidth: 2,
      anchorFill: theme.selectionColor,
      anchorStroke: "#fff",
      anchorStrokeWidth: 2,
      anchorSize: 14,
      anchorCornerRadius: 7
    }
  };
};
var applyScale = (node) => {
  const width = Math.max(MIN_ELEMENT_SIZE, node.width() * node.scaleX());
  const height = Math.max(MIN_ELEMENT_SIZE, node.height() * node.scaleY());
  node.scaleX(1);
  node.scaleY(1);
  node.width(width);
  node.height(height);
};
var parseColor = (color) => {
  const hex = color.trim().replace("#", "");
  const full = hex.length === 3 ? hex.split("").map((char) => char + char).join("") : hex;
  if (!/^[0-9a-f]{6}$/i.test(full))
    return null;
  return [0, 2, 4].map((index) => parseInt(full.slice(index, index + 2), 16));
};
var getLabelColor = (fill, darkColor = "#000") => {
  const rgb = parseColor(fill || "");
  if (!rgb)
    return darkColor;
  const [red, green, blue] = rgb.map((value) => {
    const channel = value / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
  return luminance > 0.5 ? darkColor : "#fff";
};

// src/components/editor/Image.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var EditorImage = ({
  id,
  x,
  y,
  width,
  height,
  rotation,
  sampleImage,
  theme = {},
  isAdmin,
  isSelected,
  onDragEnd,
  onContextMenu,
  onSelect,
  onTransform,
  onTransformEnd
}) => {
  const [image] = (0, import_use_image.default)(sampleImage);
  const shapeRef = (0, import_react.useRef)(null);
  const trRef = (0, import_react.useRef)(null);
  (0, import_react.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([shapeRef.current]);
  }, [isAdmin, isSelected]);
  (0, import_react.useEffect)(() => {
    var _a;
    (_a = trRef.current) == null ? void 0 : _a.forceUpdate();
  }, [width, height]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva.Image, {
        image,
        id,
        ref: shapeRef,
        draggable: isAdmin,
        listening: isAdmin,
        x,
        y,
        width,
        height,
        rotation,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0,
        onDragEnd,
        onContextMenu: isAdmin ? onContextMenu : () => {
        },
        onTransform,
        onTransformEnd: (e) => {
          applyScale(e.target);
          onTransformEnd(e);
        },
        preventDefault: isAdmin
      }),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva.Transformer, {
        ref: trRef,
        ...getTransformerProps(theme, { resize: true }, trRef)
      })
    ]
  });
};
var Image_default = EditorImage;

// src/components/editor/ContextMenu.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var ContextMenu = ({
  isVisible,
  coordinates,
  currentElementId,
  deleteElement
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Menu, {
    isVisible,
    coordinates,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MenuButton, {
        onClick: () => deleteElement && deleteElement(currentElementId),
        children: "Delete"
      })
    })
  });
};
var Menu = import_styled_components.default.div`
  display: ${({ isVisible }) => isVisible ? "block" : "none"};
  position: absolute;
  width: 60px;
  background-color: white;
  box-shadow: 0 0 5px grey;
  border-radius: 3px;
  top: ${({ coordinates }) => coordinates.y}px;
  left: ${({ coordinates }) => coordinates.x}px;
`;
var MenuButton = import_styled_components.default.div`
  padding: 5px;
  cursor: pointer;
`;
var ContextMenu_default = ContextMenu;

// src/components/editor/Grid.tsx
var import_react_konva2 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var Grid = ({
  width,
  height,
  size = 25,
  color = "#ddd"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva2.Shape, {
    sceneFunc: (context, shape) => {
      const verticalCount = width / size;
      const horizontalCount = height / size;
      for (let i = 1; i < verticalCount; i++) {
        context.beginPath();
        context.moveTo(i * size, 0);
        context.lineTo(i * size, height);
        context.fillStrokeShape(shape);
      }
      for (let i = 1; i < horizontalCount; i++) {
        context.beginPath();
        context.moveTo(0, i * size);
        context.lineTo(width, i * size);
        context.fillStrokeShape(shape);
      }
    },
    stroke: color,
    strokeWidth: 1,
    listening: false
  });
};
var Grid_default = Grid;

// src/components/editor/Area.tsx
var import_react2 = require("react");
var import_react_konva3 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var Area = ({
  isAdmin,
  isSelected = false,
  isChosen = false,
  theme = {},
  onDragEnd,
  x,
  y,
  width,
  height,
  onClick,
  onTouchEnd,
  onSelect,
  onContextMenu,
  onTransform,
  onTransformEnd,
  id,
  fill,
  isClickable
}) => {
  const groupRef = (0, import_react2.useRef)(null);
  const trRef = (0, import_react2.useRef)(null);
  (0, import_react2.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([groupRef.current]);
  }, [isAdmin, isSelected]);
  (0, import_react2.useEffect)(() => {
    var _a;
    (_a = trRef.current) == null ? void 0 : _a.forceUpdate();
  }, [width, height]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_konva3.Group, {
        ref: groupRef,
        draggable: isAdmin,
        onDragEnd,
        x,
        y,
        width,
        height,
        onClick,
        onTouchEnd,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0,
        onContextMenu: isAdmin ? onContextMenu : () => {
        },
        onTransform,
        onTransformEnd: (e) => {
          applyScale(e.target);
          onTransformEnd == null ? void 0 : onTransformEnd(e);
        },
        id,
        listening: isClickable || isAdmin,
        onMouseEnter: isClickable ? (e) => {
          const container = e.target.getStage().container();
          container.style.cursor = "pointer";
        } : void 0,
        onMouseLeave: isClickable ? (e) => {
          const container = e.target.getStage().container();
          container.style.cursor = "default";
        } : void 0,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva3.Rect, {
            width,
            height,
            fill,
            id,
            ...getBoxStyle(theme, isSelected),
            ...isChosen && getRingStyle(theme)
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva3.Text, {
            text: id,
            width,
            height,
            align: "center",
            verticalAlign: "middle",
            id,
            fontSize: 10,
            ...getTextStyle(theme),
            fill: getLabelColor(fill, theme.textColor)
          })
        ]
      }),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva3.Transformer, {
        ref: trRef,
        ...getTransformerProps(
          theme,
          { resize: true, rotate: false },
          trRef
        )
      })
    ]
  });
};
var Area_default = Area;

// src/components/editor/Rectangle.tsx
var import_react3 = require("react");
var import_react_konva4 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var Rectangle = ({
  id,
  isAdmin,
  width,
  height,
  fill,
  label,
  x,
  y,
  rotation,
  theme = {},
  isSelected,
  onDragEnd,
  onSelect,
  onContextMenu,
  onTransform,
  onTransformEnd
}) => {
  const shapeRef = (0, import_react3.useRef)(null);
  const trRef = (0, import_react3.useRef)(null);
  const isVertical = height > width;
  (0, import_react3.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([shapeRef.current]);
  }, [isAdmin, isSelected]);
  (0, import_react3.useEffect)(() => {
    var _a;
    (_a = trRef.current) == null ? void 0 : _a.forceUpdate();
  }, [width, height]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_konva4.Group, {
        ref: shapeRef,
        id,
        x,
        y,
        width,
        height,
        rotation,
        draggable: isAdmin,
        listening: isAdmin,
        onDragEnd,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0,
        onContextMenu: isAdmin ? onContextMenu : () => {
        },
        onTransform,
        onTransformEnd: (e) => {
          applyScale(e.target);
          onTransformEnd(e);
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva4.Rect, {
            id,
            width,
            height,
            fill,
            ...getBoxStyle(theme, isSelected)
          }),
          label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva4.Group, {
            clipX: 0,
            clipY: 0,
            clipWidth: width,
            clipHeight: height,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva4.Text, {
              id,
              text: label,
              x: isVertical ? width : 0,
              width: isVertical ? height : width,
              height: isVertical ? width : height,
              rotation: isVertical ? 90 : 0,
              align: "center",
              verticalAlign: "middle",
              wrap: label.includes(" ") ? "word" : "none",
              fontSize: 10,
              ...getTextStyle(theme),
              fill: getLabelColor(fill, theme.textColor)
            })
          })
        ]
      }),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva4.Transformer, {
        ref: trRef,
        ...getTransformerProps(theme, { resize: true }, trRef)
      })
    ]
  });
};
var Rectangle_default = Rectangle;

// src/components/editor/Text.tsx
var import_react4 = require("react");
var import_react_konva5 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var EditorText = ({
  id,
  x,
  y,
  text,
  rotation,
  theme = {},
  isAdmin,
  isSelected,
  onDragEnd,
  onContextMenu,
  onSelect,
  onTransformEnd
}) => {
  const shapeRef = (0, import_react4.useRef)(null);
  const trRef = (0, import_react4.useRef)(null);
  (0, import_react4.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([shapeRef.current]);
  }, [isAdmin, isSelected]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva5.Text, {
        ref: shapeRef,
        x,
        y,
        text,
        id,
        ...getTextStyle(theme),
        listening: isAdmin,
        rotation,
        draggable: isAdmin,
        onDragEnd,
        onContextMenu: isAdmin ? onContextMenu : () => {
        },
        onTransformEnd,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0
      }, id),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva5.Transformer, {
        ref: trRef,
        ...getTransformerProps(theme)
      })
    ]
  });
};
var Text_default = EditorText;

// src/components/editor/Line.tsx
var import_react5 = require("react");
var import_react_konva6 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var EditorLine = ({
  id,
  x,
  y,
  points,
  tension,
  stroke,
  strokeWidth,
  rotation,
  theme = {},
  isAdmin,
  isSelected,
  onSelect,
  onDragEnd,
  onContextMenu,
  onTransformEnd
}) => {
  const shapeRef = (0, import_react5.useRef)(null);
  const trRef = (0, import_react5.useRef)(null);
  (0, import_react5.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([shapeRef.current]);
  }, [isAdmin, isSelected]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva6.Line, {
        id,
        ref: shapeRef,
        x,
        y,
        listening: isAdmin,
        points,
        tension,
        stroke,
        strokeWidth,
        rotation,
        draggable: isAdmin,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0,
        onDragEnd,
        onContextMenu: isAdmin ? onContextMenu : () => {
        },
        onTransformEnd
      }),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva6.Transformer, {
        ref: trRef,
        ...getTransformerProps(theme)
      })
    ]
  });
};
var Line_default = EditorLine;

// src/components/editor/Circle.tsx
var import_react6 = require("react");
var import_react_konva7 = require("react-konva");
var import_jsx_runtime = require("react/jsx-runtime");
var EditorCircle = ({
  id,
  x,
  y,
  radius,
  fill,
  theme = {},
  isAdmin,
  isSelected,
  onSelect,
  onDragEnd,
  onContextMenu,
  onTransform,
  onTransformEnd
}) => {
  const shapeRef = (0, import_react6.useRef)(null);
  const trRef = (0, import_react6.useRef)(null);
  (0, import_react6.useEffect)(() => {
    isAdmin && isSelected && trRef.current.nodes([shapeRef.current]);
  }, [isAdmin, isSelected]);
  (0, import_react6.useEffect)(() => {
    var _a;
    (_a = trRef.current) == null ? void 0 : _a.forceUpdate();
  }, [radius]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva7.Circle, {
        ref: shapeRef,
        id,
        x,
        y,
        fill,
        radius,
        draggable: isAdmin,
        listening: isAdmin,
        onMouseDown: isAdmin ? onSelect : void 0,
        onTouchStart: isAdmin ? onSelect : void 0,
        onDragEnd,
        onContextMenu: isAdmin ? onContextMenu : () => null,
        onTransform,
        onTransformEnd: (e) => {
          const node = e.target;
          node.radius(
            Math.max(MIN_ELEMENT_SIZE / 2, node.radius() * node.scaleX())
          );
          node.scaleX(1);
          node.scaleY(1);
          onTransformEnd == null ? void 0 : onTransformEnd(e);
        },
        preventDefault: isAdmin,
        ...getStrokeStyle(theme, isSelected)
      }),
      isAdmin && isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva7.Transformer, {
        ref: trRef,
        ...getTransformerProps(
          theme,
          { resize: true, rotate: false, keepRatio: true },
          trRef
        )
      })
    ]
  });
};
var Circle_default = EditorCircle;

// src/store/FormContext.tsx
var import_react7 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var FormContext = (0, import_react7.createContext)(null);
var initialFormState = {
  location: "",
  booth: "",
  duration: "",
  email: "",
  fullName: "",
  phone: "",
  ssn: ""
};
var reducer = (state, action) => {
  switch (action.type) {
    case action.type:
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};
var FormContextProvider = ({
  children
}) => {
  const [step, setStep] = (0, import_react7.useState)(1);
  const [formState, dispatchFormState] = (0, import_react7.useReducer)(reducer, initialFormState);
  const [price, setPrice] = (0, import_react7.useState)("");
  const [startDate, setStartDate] = (0, import_react7.useState)(null);
  const [endDate, setEndDate] = (0, import_react7.useState)(null);
  const [locationBooths, setLocationBooths] = (0, import_react7.useState)([]);
  const [freeDays, setFreeDays] = (0, import_react7.useState)([]);
  const [storeBackground, setStoreBackground] = (0, import_react7.useState)("");
  const [floormapConfig, setFloormapConfig] = (0, import_react7.useState)([]);
  const [rentals, setRentals] = (0, import_react7.useState)([]);
  const [boothType, setBoothType] = (0, import_react7.useState)(null);
  const [chosenBooth, setChosenBooth] = (0, import_react7.useState)(null);
  const handleFormChange = ({ key, value: value2 }) => dispatchFormState({ type: key, value: value2 });
  const { location, booth, duration, email, fullName, phone, ssn } = formState;
  const value = {
    step,
    price,
    form: {
      location,
      booth,
      duration,
      email,
      fullName,
      phone,
      ssn
    },
    rentals,
    locationBooths,
    freeDays,
    storeBackground,
    floormapConfig,
    startDate,
    endDate,
    boothType,
    chosenBooth,
    setStep,
    handleFormChange,
    setPrice,
    setRentals,
    setLocationBooths,
    setFreeDays,
    setStoreBackground,
    setFloormapConfig,
    setStartDate,
    setEndDate,
    setBoothType,
    setChosenBooth
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormContext.Provider, {
    value,
    children
  });
};
var FormContext_default = FormContextProvider;

// src/editor.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var isBoothAvailable = (booth, start, end) => {
  var _a;
  if (!booth)
    return false;
  if (booth.valid_start_dates != null) {
    return booth.valid_start_dates.length > 0;
  }
  if (!(booth == null ? void 0 : booth.unavailable_dates))
    return false;
  if (!start || !end)
    return false;
  return !((_a = booth.unavailable_dates) == null ? void 0 : _a.some(
    (date) => (0, import_date_fns.isWithinInterval)((0, import_date_fns.parseISO)(date), {
      start,
      end
    })
  ));
};
var EditorContent = ({
  isAdmin,
  className,
  theme,
  maxWidth,
  minScale = 0,
  selectedId: controlledSelectedId,
  onSelect,
  floormapConfig,
  locationBooths,
  startDate = new Date(),
  endDate = new Date(),
  chosenBoothColor = "orange",
  boothColor = "orange",
  unavailableBoothColor = "red",
  availableBoothColor = "green",
  secondaryAvailableBoothColor = "lightgreen",
  chosenBoothType,
  chosenBooth,
  handleDragMove,
  handleDragEnd,
  handleTransform,
  transformElement,
  deleteElement,
  onChosenBooth
}) => {
  const stageRef = (0, import_react8.useRef)(null);
  const defaultWidth = String(DEFAULT_FLOOR_SIZE.width);
  const defaultHeight = String(DEFAULT_FLOOR_SIZE.height);
  const [floorWidth, setFloorWidth] = (0, import_react8.useState)(defaultWidth);
  const [floorHeight, setFloorHeight] = (0, import_react8.useState)(defaultHeight);
  const scale = maxWidth ? Math.min(1, Math.max(minScale, maxWidth / +floorWidth)) : 1;
  const [isContextMenuVisible, setIsContextMenuVisible] = (0, import_react8.useState)(false);
  const [currentElementId, setCurrentElementId] = (0, import_react8.useState)("");
  const [contextMenuCoordinates, setContextMenuCoordinates] = (0, import_react8.useState)({
    x: 0,
    y: 0
  });
  const [internalSelectedId, setInternalSelectedId] = (0, import_react8.useState)(
    null
  );
  const selectedId = controlledSelectedId === void 0 ? internalSelectedId : controlledSelectedId;
  const setSelectedId = (id) => onSelect ? onSelect(id) : setInternalSelectedId(id);
  const handleLayerRightClick = (e) => {
    e.evt.preventDefault();
    const { pageX, pageY } = e.evt;
    setCurrentElementId(e.target.attrs.id);
    setContextMenuCoordinates({ x: pageX, y: pageY });
    setIsContextMenuVisible(true);
  };
  const setDragCursor = (e, cursor) => {
    const draggable = e.target.findAncestor(
      (node) => node.draggable(),
      true
    );
    if (draggable)
      e.target.getStage().container().style.cursor = cursor;
  };
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      setSelectedId(null);
    }
  };
  const handleSingleBoothClick = (e) => {
    var _a;
    if (isAdmin)
      return false;
    const booth = Array.isArray(locationBooths) && locationBooths.length > 0 ? locationBooths.find(
      (booth2) => booth2.number === parseInt(e.target.attrs.id, 10)
    ) : null;
    if ((booth == null ? void 0 : booth.booth_type) !== chosenBoothType)
      return false;
    const isAvailable = isBoothAvailable(booth, startDate, endDate);
    if (!isAvailable)
      return false;
    if (booth == null) {
      console.log("booth not found, something went wrong");
    }
    if (booth != null) {
      onChosenBooth && onChosenBooth({
        id: booth.pk,
        number: booth.number,
        date: (_a = booth.valid_start_dates) == null ? void 0 : _a[0]
      });
    }
  };
  (0, import_react8.useEffect)(() => {
    window.addEventListener("click", () => {
      setIsContextMenuVisible(false);
    });
  }, []);
  (0, import_react8.useEffect)(() => {
    if ((floormapConfig == null ? void 0 : floormapConfig.findIndex((config) => config.type === "floorDimentions")) !== -1) {
      const { width, height } = floormapConfig.find((config) => config.type === "floorDimentions");
      setFloorWidth(width);
      setFloorHeight(height);
    }
  }, [floormapConfig]);
  const colorBooth = (id) => {
    if (isAdmin)
      return boothColor;
    const currentBooth = locationBooths == null ? void 0 : locationBooths.find((item) => item.number === +id);
    const isAvailable = isBoothAvailable(currentBooth, startDate, endDate);
    if (!currentBooth)
      return "#000";
    if (chosenBooth.id === currentBooth.pk)
      return chosenBoothColor;
    return isAvailable ? currentBooth.booth_type === chosenBoothType ? availableBoothColor : secondaryAvailableBoothColor : unavailableBoothColor;
  };
  const isBoothChosen = (id) => {
    if (isAdmin)
      return false;
    const currentBooth = locationBooths == null ? void 0 : locationBooths.find((item) => item.number === +id);
    return !!currentBooth && (chosenBooth == null ? void 0 : chosenBooth.id) === currentBooth.pk;
  };
  const isBoothClickable = (id) => {
    if (isAdmin)
      return false;
    const currentBooth = locationBooths == null ? void 0 : locationBooths.find((item) => item.number === +id);
    if ((currentBooth == null ? void 0 : currentBooth.booth_type) !== chosenBoothType)
      return false;
    return isBoothAvailable(currentBooth, startDate, endDate);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
    className,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EditorWrapper, {
        className: "editor-wrapper",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_konva8.Stage, {
          width: +floorWidth * scale,
          height: +floorHeight * scale,
          scaleX: scale,
          scaleY: scale,
          ref: stageRef,
          id: "editor-container",
          onMouseDown: checkDeselect,
          onTouchStart: checkDeselect,
          preventDefault: isAdmin,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_konva8.Layer, {
            preventDefault: isAdmin,
            onMouseOver: isAdmin ? (e) => setDragCursor(e, "grab") : void 0,
            onMouseOut: isAdmin ? (e) => setDragCursor(e, "") : void 0,
            onDragStart: isAdmin ? (e) => setDragCursor(e, "grabbing") : void 0,
            onDragMove: isAdmin ? (e) => e.target.draggable() && (handleDragMove == null ? void 0 : handleDragMove(e)) : void 0,
            onDragEnd: isAdmin ? (e) => setDragCursor(e, "grab") : void 0,
            children: [
              isAdmin && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Grid_default, {
                width: +floorWidth,
                height: +floorHeight,
                size: theme == null ? void 0 : theme.gridSize,
                color: theme == null ? void 0 : theme.gridColor
              }),
              floormapConfig != null && Array.isArray(floormapConfig) && (floormapConfig == null ? void 0 : floormapConfig.map((element) => {
                if (element.type === "floorDimentions") {
                  return null;
                } else if (element.type === "booth") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Area_default, {
                    ...element,
                    isAdmin,
                    isSelected: isAdmin && element.id === selectedId,
                    isChosen: isBoothChosen(element.id),
                    theme,
                    onDragEnd: handleDragEnd,
                    onContextMenu: handleLayerRightClick,
                    onClick: handleSingleBoothClick,
                    onTouchEnd: handleSingleBoothClick,
                    onSelect: () => setSelectedId(element.id),
                    onTransform: handleTransform,
                    onTransformEnd: transformElement,
                    fill: colorBooth(element.id),
                    isClickable: isBoothClickable(element.id)
                  }, element.id);
                } else if (element.type === "rect") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Rectangle_default, {
                    ...element,
                    theme,
                    isAdmin,
                    isSelected: element.id === selectedId,
                    onDragEnd: handleDragEnd,
                    onSelect: () => setSelectedId(element.id),
                    onContextMenu: handleLayerRightClick,
                    onTransform: handleTransform,
                    onTransformEnd: transformElement,
                    preventDefault: isAdmin
                  }, element.id);
                } else if (element.type === "text") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, {
                    ...element,
                    theme,
                    isAdmin,
                    isSelected: element.id === selectedId,
                    onDragEnd: handleDragEnd,
                    onSelect: () => setSelectedId(element.id),
                    onContextMenu: handleLayerRightClick,
                    onTransformEnd: transformElement
                  }, element.id);
                } else if (element.type === "circle") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Circle_default, {
                    id: element.id,
                    x: element.x,
                    y: element.y,
                    fill: element.fill,
                    radius: element.radius,
                    theme,
                    isAdmin,
                    isSelected: element.id === selectedId,
                    onSelect: () => setSelectedId(element.id),
                    onDragEnd: handleDragEnd,
                    onContextMenu: handleLayerRightClick,
                    onTransform: handleTransform,
                    onTransformEnd: transformElement
                  }, element.id);
                } else if (element.type === "line") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Line_default, {
                    ...element,
                    theme,
                    isAdmin,
                    isSelected: element.id === selectedId,
                    onSelect: () => setSelectedId(element.id),
                    onDragEnd: handleDragEnd,
                    onContextMenu: handleLayerRightClick,
                    onTransformEnd: transformElement,
                    preventDefault: isAdmin
                  }, element.id);
                } else if (element.type === "image") {
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Image_default, {
                    ...element,
                    theme,
                    isAdmin,
                    sampleImage: element.src,
                    isSelected: element.id === selectedId,
                    onSelect: () => setSelectedId(element.id),
                    onDragEnd: handleDragEnd,
                    onContextMenu: handleLayerRightClick,
                    onTransform: handleTransform,
                    onTransformEnd: transformElement,
                    preventDefault: isAdmin
                  }, element.id);
                } else {
                  return element;
                }
              }))
            ]
          })
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContextMenu_default, {
        isVisible: isContextMenuVisible,
        coordinates: contextMenuCoordinates,
        currentElementId,
        deleteElement
      })
    ]
  });
};
var Editor = ({
  isAdmin = false,
  className,
  theme,
  maxWidth,
  minScale,
  selectedId,
  onSelect,
  floormapConfig = [],
  locationBooths = [],
  startDate,
  endDate,
  availableBoothColor,
  unavailableBoothColor,
  chosenBoothColor,
  boothColor,
  chosenBoothType,
  secondaryAvailableBoothColor,
  chosenBooth,
  handleDragMove,
  handleDragEnd,
  handleTransform,
  transformElement,
  deleteElement,
  onChosenBooth
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormContext_default, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EditorContent, {
      isAdmin,
      className,
      theme,
      maxWidth,
      minScale,
      selectedId,
      onSelect,
      floormapConfig,
      handleDragMove,
      handleDragEnd,
      handleTransform,
      transformElement,
      deleteElement,
      locationBooths,
      startDate,
      endDate,
      onChosenBooth,
      availableBoothColor,
      unavailableBoothColor,
      chosenBoothColor,
      chosenBoothType,
      secondaryAvailableBoothColor,
      chosenBooth,
      boothColor
    })
  });
};
var Wrapper = import_styled_components2.default.div`
  display: flex;
  align-items: flex-start;
`;
var EditorWrapper = import_styled_components2.default.div``;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DEFAULT_FLOOR_SIZE,
  Editor,
  EditorContent,
  MAP_THEME,
  MIN_ELEMENT_SIZE
});
